export default __webpack_public_path__ + "static/media/Plan2026.8f5374ac.svg";